import React from "react";
import cerca from "../../assets/v2/searching.svg";
import report from "../../assets/v2/report.svg";
import users from "../../assets/v2/team.svg";
import segnalazioni from "../../assets/v2/file.svg";
import referente from "../../assets/v2/hospital.svg";
import {
    amber,
    blue,
    brown,
    deepOrange,
    deepPurple,
    lightBlue,
    lightGreen,
    orange,
    yellow
} from "@mui/material/colors";
import SearchTwoToneIcon from '@mui/icons-material/SearchTwoTone';
import AssignmentTwoToneIcon from '@mui/icons-material/AssignmentTwoTone';
import MultilineChartTwoToneIcon from '@mui/icons-material/MultilineChartTwoTone';
import FaceTwoToneIcon from '@mui/icons-material/FaceTwoTone';
import VpnKeyTwoToneIcon from '@mui/icons-material/VpnKeyTwoTone';
import HeadsetMicTwoToneIcon from '@mui/icons-material/HeadsetMicTwoTone';
import LiveHelpTwoToneIcon from '@mui/icons-material/LiveHelpTwoTone';
import EventTwoToneIcon from '@mui/icons-material/EventTwoTone';
import {
    AssignmentRounded,
    EventRounded,
    FaceRounded,
    HeadsetMicRounded,
    LiveHelpRounded,
    MultilineChartRounded,
    SearchRounded,
    VpnKeyRounded
} from "@mui/icons-material";
import {AutoAwesomeTwoTone, Category, CategoryRounded} from "@mui/icons-material";


export const actions = {
    // 0: {
    // 	name: <React.Fragment>Carico dati</React.Fragment>,
    // 	path: "/gestione/carico",
    // 	description: "Pannello per il caricamento di positivi, anagrafiche e tamponi.",
    // 	group: "A",
    // 	src: upload,
    // 	roles: ["ROLE_SUPERADMIN", "ROLE_UPLOADER"],
    // 	bgColor: red["50"],
    // 	bgColorDark: red["900"],
    // 	color: "#000",
    // 	icon: <BackupTwoToneIcon style={{color: red[900]}}/>,
    // 	iconNoStyle: <BackupTwoToneIcon/>,
    // 	iconRoundedNoStyle: <BackupRoundedIcon/>,
    // 	iconDark: <BackupTwoToneIcon style={{color: red[50]}}/>,
    // },
    // 1: {
    // 	name: <React.Fragment>Gestione tamponi</React.Fragment>,
    // 	path: "/gestione/tamponi",
    // 	description: "Pannello per la gestione dei tamponi postivi da intervistare.",
    // 	group: "A",
    // 	src: tamponi,
    // 	roles: ["ROLE_SUPERADMIN", "ROLE_SP_301"],
    // 	bgColor: pink["50"],
    // 	bgColorDark: pink["900"],
    // 	color: "#000",
    // 	icon: <ColorizeTwoToneIcon style={{color: pink[900]}}/>,
    // 	iconNoStyle: <ColorizeTwoToneIcon/>,
    // 	iconRoundedNoStyle: <ColorizeRoundedIcon/>,
    // 	iconDark: <ColorizeTwoToneIcon style={{color: pink[50]}}/>,
    // },
    // 3: {
    // 	name: <React.Fragment>Gestione interviste</React.Fragment>,
    // 	path: "/gestione/interviste",
    // 	description: "Gestione delle interviste ai pazienti positivi",
    // 	group: "A",
    // 	src: interviste,
    // 	roles: ["ROLE_SUPERADMIN", /*"ROLE_SP_301"*/],
    // 	bgColor: deepPurple["50"],
    // 	bgColorDark: deepPurple["900"],
    // 	color: "#000",
    // 	icon: <MicNoneTwoToneIcon style={{color: deepPurple[900]}}/>,
    // 	iconNoStyle: <MicNoneTwoToneIcon/>,
    // 	iconRoundedNoStyle: <MicNoneTwoToneIcon/>,
    // 	iconDark: <MicNoneTwoToneIcon style={{color: deepPurple[50]}}/>,
    // },
    // 4: {
    // 	name: <React.Fragment>Autosorveglianze ed isolamenti</React.Fragment>,
    // 	path: "/gestione/quarantene",
    // 	description: "Gestione delle autosorveglianze, isolamenti e monitoraggi attuali e passati.",
    // 	group: "B",
    // 	src: quarantene,
    // 	roles: ["ROLE_SUPERADMIN", "ROLE_SP_301"],
    // 	bgColor: indigo["50"],
    // 	bgColorDark: indigo["900"],
    // 	color: "#000",
    // 	icon: <DateRangeTwoToneIcon style={{color: indigo[900]}}/>,
    // 	iconNoStyle: <DateRangeTwoToneIcon/>,
    // 	iconRoundedNoStyle: <DateRangeRounded/>,
    // 	iconDark: <DateRangeTwoToneIcon style={{color: indigo[50]}}/>,
    // },
    // 5: {
    // 	name: <React.Fragment>Calendario isolamenti</React.Fragment>,
    // 	path: "/gestione/scadenziario",
    // 	description: "Gestione delle autosorveglianze e degli isolamenti con scadenze",
    // 	group: "B",
    // 	src: quarantene,
    // 	roles: ["ROLE_SUPERADMIN", "ROLE_SP_301"],
    // 	bgColor: deepPurple["50"],
    // 	bgColorDark: deepPurple["900"],
    // 	color: "#000",
    // 	icon: <EventNoteTwoToneIcon style={{color: deepPurple[900]}}/>,
    // 	iconNoStyle: <EventNoteTwoToneIcon/>,
    // 	iconRoundedNoStyle: <EventNoteRounded/>,
    // 	iconDark: <EventNoteTwoToneIcon style={{color: deepPurple[50]}}/>,
    // },
    6: {
        name: <React.Fragment>Gestione ticket</React.Fragment>,
        path: "/gestione/tickets",
        description: "Gestione delle segnalazioni sostitutive delle varie mail che arrivano dai cittadini.",
        group: "C",
        src: segnalazioni,
        roles: ["ROLE_SUPERADMIN", "ROLE_OPERATOR"],
        bgColor: lightBlue["50"],
        bgColorDark: lightBlue["900"],
        color: "#000",
        icon: <AssignmentTwoToneIcon style={{color: lightBlue[900]}}/>,
        iconNoStyle: <AssignmentTwoToneIcon/>,
        iconRoundedNoStyle: <AssignmentRounded/>,
        iconDark: <AssignmentTwoToneIcon style={{color: lightBlue[50]}}/>,
    },
    7: {
        name: <React.Fragment>Ricerca anagrafica</React.Fragment>,
        path: "/gestione/pazienti",
        description: "Ricerca un paziente tramite uno o più campi dell'anagrafica.",
        group: "C",
        src: cerca,
        roles: ["ROLE_SUPERADMIN", "ROLE_SP_301", "ROLE_SP_301_H"],
        bgColor: blue["50"],
        bgColorDark: blue["900"],
        color: "#000",
        icon: <SearchTwoToneIcon style={{color: blue[900]}}/>,
        iconNoStyle: <SearchTwoToneIcon/>,
        iconRoundedNoStyle: <SearchRounded/>,
        iconDark: <SearchTwoToneIcon style={{color: blue[50]}}/>,
    },
    // 8: {
    // 	name: <React.Fragment>Gestione comunità</React.Fragment>,
    // 	path: "/gestione/comunita",
    // 	description: "Gestione delle segnalazioni che arrivano dalle comunità.",
    // 	group: "C",
    // 	src: comunita,
    // 	roles: ["ROLE_SUPERADMIN"],
    // 	bgColor: cyan["50"],
    // 	bgColorDark: cyan["900"],
    // 	color: "#000",
    // 	icon: <PeopleAltTwoToneIcon style={{color: cyan[900]}}/>,
    // 	iconNoStyle: <PeopleAltTwoToneIcon/>,
    // 	iconRoundedNoStyle: <PeopleAltRounded/>,
    // 	iconDark: <PeopleAltTwoToneIcon style={{color: cyan[50]}}/>,
    // },
    // 9: {
    // 	name: <React.Fragment>Catalogo scuole</React.Fragment>,
    // 	path: "/gestione/scuole",
    // 	description: "Gestione del catalogo dei progetti con le scuole.",
    // 	group: "C",
    // 	src: scuole,
    // 	roles: ["ROLE_SUPERADMIN"],
    // 	bgColor: teal["50"],
    // 	bgColorDark: teal["900"],
    // 	color: "#000",
    // 	icon: <SchoolTwoToneIcon style={{color: teal[900]}}/>,
    // 	iconNoStyle: <SchoolTwoToneIcon/>,
    // 	iconRoundedNoStyle: <SchoolRounded/>,
    // 	iconDark: <SchoolTwoToneIcon style={{color: teal[50]}}/>,
    // },
    // 10: {
    // 	name: <React.Fragment>Gestione focolai</React.Fragment>,
    // 	path: "/gestione/focolai",
    // 	description: "Visualizzazione dei vari focolai presenti in base alle quarantene attuali.",
    // 	group: "C",
    // 	src: focolai,
    // 	roles: ["ROLE_SUPERADMIN", "ROLE_SP_301"],
    // 	bgColor: green["50"],
    // 	bgColorDark: green["900"],
    // 	color: "#000",
    // 	icon: <WhatshotTwoToneIcon style={{color: green[900]}}/>,
    // 	iconNoStyle: <WhatshotTwoToneIcon/>,
    // 	iconRoundedNoStyle: <WhatshotRounded/>,
    // 	iconDark: <WhatshotTwoToneIcon style={{color: green[50]}}/>,
    // },
    11: {
        name: <React.Fragment>Report e grafici</React.Fragment>,
        path: "/gestione/report",
        description: "Visualizzazione grafica dell'andamento dei pazienti e della situazione monitoraggi.",
        group: "C",
        src: report,
        roles: ["ROLE_SUPERADMIN", "ROLE_DELEGATO", "ROLE_REFERENTE", "ROLE_COMPANY", "ROLE_GRAFICI"],
        bgColor: lightGreen["50"],
        bgColorDark: lightGreen["900"],
        color: "#000",
        icon: <MultilineChartTwoToneIcon style={{color: lightGreen[900]}}/>,
        iconNoStyle: <MultilineChartTwoToneIcon/>,
        iconRoundedNoStyle: <MultilineChartRounded/>,
        iconDark: <MultilineChartTwoToneIcon style={{color: lightGreen[50]}}/>,
    },
    13: {
        name: <React.Fragment>Gestione utenti</React.Fragment>,
        path: "/gestione/utenti",
        description: "Gestione degli utenti da certificare e verificare.",
        group: "C",
        src: users,
        roles: ["ROLE_SUPERADMIN"],
        bgColor: yellow["50"],
        bgColorDark: yellow["900"],
        color: "#000",
        icon: <FaceTwoToneIcon style={{color: yellow[900]}}/>,
        iconNoStyle: <FaceTwoToneIcon/>,
        iconRoundedNoStyle: <FaceRounded/>,
        iconDark: <FaceTwoToneIcon style={{color: yellow[50]}}/>,
    },
    14: {
        name: <React.Fragment>Referente azienda</React.Fragment>,
        path: "/gestione/azienda",
        description: "Gestione degli utenti dell'azienda.",
        group: "C",
        src: referente,
        roles: ["ROLE_SUPERADMIN", "ROLE_COMPANY", "ROLE_DELEGATO"],
        bgColor: amber["50"],
        bgColorDark: amber["900"],
        color: "#000",
        icon: <VpnKeyTwoToneIcon style={{color: amber[900]}}/>,
        iconNoStyle: <VpnKeyTwoToneIcon/>,
        iconRoundedNoStyle: <VpnKeyRounded/>,
        iconDark: <VpnKeyTwoToneIcon style={{color: amber[50]}}/>,
    },
    15: {
        name: <React.Fragment>Callcenter form</React.Fragment>,
        path: "/gestione/callcenter",
        description: "Gestione delle chiamate che arrivano dai cittadini.",
        group: "C",
        src: segnalazioni,
        roles: ["ROLE_SUPERADMIN", "ROLE_OPERATOR"],
        bgColor: orange["50"],
        bgColorDark: orange["900"],
        color: "#000",
        icon: <HeadsetMicTwoToneIcon style={{color: orange[900]}}/>,
        iconNoStyle: <HeadsetMicTwoToneIcon/>,
        iconRoundedNoStyle: <HeadsetMicRounded/>,
        iconDark: <HeadsetMicTwoToneIcon style={{color: orange[50]}}/>,
    },
    16: {
        name: <React.Fragment>Gestione FAQ</React.Fragment>,
        path: "/gestione/faq",
        description: "Gestione delle FAQ per i cittadini.",
        group: "C",
        src: segnalazioni,
        roles: ["ROLE_SUPERADMIN", "ROLE_SP_301"],
        bgColor: deepOrange["50"],
        bgColorDark: deepOrange["900"],
        color: "#000",
        icon: <LiveHelpTwoToneIcon style={{color: deepOrange[900]}}/>,
        iconNoStyle: <LiveHelpTwoToneIcon/>,
        iconRoundedNoStyle: <LiveHelpRounded/>,
        iconDark: <LiveHelpTwoToneIcon style={{color: deepOrange[50]}}/>,
    },
    18: {
        name: <React.Fragment>Appuntamenti ed agende</React.Fragment>,
        path: "/gestione/prenotazioni",
        description: "Gestione degli appuntamenti e delle agende di disponibilità personali ed aziendali.",
        group: "C",
        src: segnalazioni,
        roles: ["ROLE_SUPERADMIN", "ROLE_SP_301"],
        bgColor: brown["50"],
        bgColorDark: brown["900"],
        color: "#000",
        icon: <EventTwoToneIcon style={{color: brown[900]}}/>,
        iconNoStyle: <EventTwoToneIcon/>,
        iconRoundedNoStyle: <EventRounded/>,
        iconDark: <EventTwoToneIcon style={{color: brown[50]}}/>,
    },
    // 19: {
    // 	name: <React.Fragment>Modulo ETS</React.Fragment>,
    // 	path: "/gestione/ets",
    // 	description: "Download delle segnalazioni ETS",
    // 	group: "C",
    // 	src: segnalazioni,
    // 	roles: ["ROLE_SUPERADMIN", "ROLE_SP_301", "ROLE_ETS"],
    // 	bgColor: grey["50"],
    // 	bgColorDark: grey["900"],
    // 	color: "#000",
    // 	icon: <AccountBalanceTwoToneIcon style={{color: grey[900]}}/>,
    // 	iconNoStyle: <AccountBalanceTwoToneIcon/>,
    // 	iconRoundedNoStyle: <AccountBalanceRounded/>,
    // 	iconDark: <AccountBalanceTwoToneIcon style={{color: grey[50]}}/>,
    // },
    // 20: {
    // 	name: <React.Fragment>Calendario tamponi</React.Fragment>,
    // 	path: "/gestione/calendario-tamponi",
    // 	description: "Calendario dei tamponi",
    // 	group: "C",
    // 	src: quarantene,
    // 	roles: ["ROLE_SUPERADMIN", "ROLE_SP_301"],
    // 	bgColor: blueGrey["50"],
    // 	bgColorDark: blueGrey["900"],
    // 	color: "#000",
    // 	icon: <EventNoteTwoToneIcon style={{color: blueGrey[900]}}/>,
    // 	iconNoStyle: <EventNoteTwoToneIcon/>,
    // 	iconRoundedNoStyle: <EventNoteRounded/>,
    // 	iconDark: <EventNoteTwoToneIcon style={{color: blueGrey[50]}}/>,
    // },
    21: {
        name: <React.Fragment>Gestione Moduli</React.Fragment>,
        path: "/gestione/moduli",
        description: "Creazione e modifica moduli dinamici",
        group: "C",
        src: segnalazioni,
        roles: ["ROLE_SUPERADMIN", "ROLE_SP_301"],
        bgColor: deepOrange["50"],
        bgColorDark: deepOrange["900"],
        color: "#000",
        icon: <LiveHelpTwoToneIcon style={{color: deepOrange[900]}}/>,
        iconNoStyle: <LiveHelpTwoToneIcon/>,
        iconRoundedNoStyle: <LiveHelpRounded/>,
        iconDark: <LiveHelpTwoToneIcon style={{color: deepOrange[50]}}/>,
    },
    22: {
        name: <React.Fragment>Gestione Categorie</React.Fragment>,
        path: "/gestione/categorie",
        description: "Gestione dell'associazione Moduli Dinamici con Categorie e Sotto Categorie",
        group: "C",
        src: segnalazioni,
        roles: ["ROLE_SUPERADMIN", "ROLE_SP_301"],
        bgColor: deepPurple["50"],
        bgColorDark: deepPurple["900"],
        color: "#000",
        icon: <CategoryRounded style={{color: deepPurple[900]}}/>,
        iconNoStyle: <Category/>,
        iconRoundedNoStyle: <CategoryRounded/>,
        iconDark: <CategoryRounded style={{color: deepPurple[50]}}/>,
    },
    23: {
        name: <React.Fragment>Impostazioni & IA</React.Fragment>,
        path: "/gestione/settings",
        description: "Gestione delle impostazioni account e IA",
        group: "C",
        src: segnalazioni,
        roles: ["ROLE_SUPERADMIN", "ROLE_SP_301"],
        bgColor: deepPurple["50"],
        bgColorDark: deepPurple["900"],
        color: "#000",
        icon: <AutoAwesomeTwoTone style={{color: deepPurple[900]}}/>,
        iconNoStyle: <AutoAwesomeTwoTone/>,
        iconRoundedNoStyle: <AutoAwesomeTwoTone/>,
        iconDark: <AutoAwesomeTwoTone style={{color: deepPurple[50]}}/>,
    },
}
